<div class="flex flex-row flex-wrap gap-x-16 gap-y-24 justify-center p-8">
    @for(pair of eventsByMonth(); track pair[0].getTime()) {
      @let month = pair[0];
      @let calendarEvents = pair[1];
      <stch-calendar-month-small
        [viewDate]="month"
        [dayTemplate]="dayTemplate"
        [events]="calendarEvents"
        [refresh]="refreshCalendar"
        class="grow min-w-sm max-w-lg"
      >
        <div class="pb-8 pt-4 text-center text-lg font-medium">
          {{ month | dateFormat: 'monthYear' }}
        </div>
      </stch-calendar-month-small>
    }
</div>

<ng-template
  #dayTemplate
  let-day="day"
>
  <stch-calendar-year-day-cell #dayRef
    [day]="day"
    [selected]="day.date | sameDisplayDay : selectedDate() : displayTimeZone"
    [popupDisabled]="contextMenuOpened"

    (eventClicked)="eventClicked.emit($event)"
    (eventDblClicked)="eventDblClicked.emit($event)"
    
    (appClick)="clickDay($event, day.date, dayRef.elementRef)"
    (appDblClick)="dblClickDay(day.date)"

    appDroppable
    appDroppableHoverClass="drag-over"
    (appDroppableDrop)="handleDrop($event, day.date, dayRef.elementRef.nativeElement)"

    [appCalendarCellContextMenu]="day.date"
    [appCalendarCellContextMenuCalendarType]="CalendarType.YEAR"
    (stchPopoverVisibleChange)="contextMenuOpened = $event"
    />
</ng-template>
